export const ENTITY_NAME = {
  ADDRESS_BOOK: "AddressBook",
  EXPORT_ADDRESS_BOOK: "ExportAddressBook",
  ADDRESS_BOOK_GROUP: "AddressBookGroup",
};

export default ENTITY_NAME;
